import { __decorate, __metadata } from "tslib";
// NPM
import { Component, Mixins, Watch } from "vue-property-decorator";
// QUINLAN
import Layout from "../../layouts/main.vue";
import PageHeader from "@/components/page-header.vue";
import BaseMixer from "@/router/views/BaseMixer";
import SecurityUsersModule from "@/store/modules/securityuser.module";
import { ChangePasswordModel } from "../../../store/models/security-users/changePassword";
import { AuthModule } from "@/store/modules/auth.module";
import { SettingModule } from "@/store/modules/settings.module";
import { toaster } from "@/utilities/toaster";
import { SecurityUserModel } from "@/store/models/security-users/securityUsers";
import SectionLoader from "@/components/widgets/SectionLoader.vue";
let Profile = /** @class */ (() => {
    let Profile = class Profile extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            //Data
            this.changePassword = new ChangePasswordModel();
            this.changePwdStep1 = true;
            this.changePwdStep2 = false;
            this.showCurrentPassword = false;
            this.showNewPassword = false;
            this.showConfirmPassword = false;
            this.userTimeZoneValue = this.userTimeZone;
            this.userDateFormatValue = this.userDateFormat;
            this.userDateFormatAndTimeZone = new SecurityUserModel();
            this.fullName = {};
            this.email = "";
            this.profileImageLoader = false;
            this.title = "Profile";
            this.items = [
                {
                    text: "Profile",
                    active: true,
                },
            ];
            this.activeMenu = null;
            this.profileImage = null;
            this.menuProfile = [
                {
                    id: 1,
                    menuName: "Account",
                    iconName: "bx bx-user",
                },
                {
                    id: 2,
                    menuName: "Change Password",
                    iconName: "bx bx-key",
                },
                {
                    id: 3,
                    menuName: "Settings",
                    iconName: "bx bx-cog",
                },
            ];
        }
        data() {
            return {
                fullName: AuthModule.fullName,
                email: AuthModule.email,
            };
        }
        showChangePwd() {
            this.changePwdStep2 = !this.changePwdStep2;
            this.changePwdStep1 = !this.changePwdStep1;
            this.changePassword.oldPassword = "";
            this.changePassword.newPassword = "";
            this.changePassword.newConfirmPassword = "";
            this.reset("updatePasswordObserver");
        }
        toggleCurrentShow() {
            this.showCurrentPassword = !this.showCurrentPassword;
        }
        toggleNewShow() {
            this.showNewPassword = !this.showNewPassword;
        }
        toggleConfirmShow() {
            this.showConfirmPassword = !this.showConfirmPassword;
        }
        UpdatePassword() {
            this.validate("updatePasswordObserver").then((response) => {
                if (response) {
                    SecurityUsersModule.UpdatePassword(this.changePassword)
                        .then((response) => {
                        console.log(this.changePassword);
                        if (response.successMessages.length > 0) {
                            toaster.ShowSuccess(`Your password has been changed successfully.`);
                            this.changePwdStep2 = !this.changePwdStep2;
                            this.changePwdStep1 = !this.changePwdStep1;
                        }
                        else {
                            alert(response.warningMessages.toString());
                        }
                    })
                        .catch((err) => console.log(err));
                }
            });
        }
        fileSelected2(e) {
            this.profileImageLoader = true;
            var newFiles = e.target.files || e.dataTransfer.files;
            if (!newFiles.length) {
                this.profileImageLoader = false;
                return;
            }
            this.profileImage = newFiles[0];
            if (this.ImageValidator(this.profileImage)) {
                if (this.ImageSizeValidator(this.profileImage)) {
                    this.uploadProfilePicture();
                }
                else {
                    this.profileImageLoader = false;
                    toaster.ShowError("Please upload a Profile picture which is less than 2 MB in size.");
                }
            }
            else {
                this.profileImageLoader = false;
                toaster.ShowError("Please upload an image with the file format as .jpg, .png or .svg.");
            }
        }
        uploadProfilePicture() {
            let formData = new FormData();
            formData.append("file", this.profileImage);
            SecurityUsersModule.UploadProfilePicture(formData).then((response) => {
                if (response) {
                    SettingModule.userProfile.profileImageUrl = response.imageUrl;
                    toaster.ShowSuccess(response.successMessages[0]);
                    this.profileImageLoader = false;
                }
            });
        }
        changeDateFormatAndTimeZone() {
            this.userDateFormatAndTimeZone.dateFormat = this.userDateFormatValue;
            this.userDateFormatAndTimeZone.timeZone = this.userTimeZoneValue;
            SettingModule.UpdateDateFormatAndTimeZone(this.userDateFormatAndTimeZone).then((response) => {
                if (response) {
                    toaster.ShowSuccess(response.successMessages[0]);
                }
            });
        }
        get getProfilePicture() {
            return SettingModule.userProfile.profileImageUrl;
        }
        get userTimeZone() {
            return SettingModule.userTimeZone;
        }
        setUsertimeZone(newValue, oldValue) {
            if (newValue) {
                this.userTimeZoneValue = this.userTimeZone;
            }
        }
        setUserDateFormat(newValue, oldValue) {
            if (newValue) {
                this.userDateFormatValue = this.userDateFormat;
            }
        }
        get userDateFormat() {
            return SettingModule.userDateFormat;
        }
        get userRole() {
            return SettingModule.userRole;
        }
        get timeZones() {
            return SettingModule.timeZones;
        }
        get DateFormats() {
            return SettingModule.dateFormats;
        }
        created() {
            this.activeMenu = this.menuProfile[0];
        }
    };
    __decorate([
        Watch("userTimeZone"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, Object]),
        __metadata("design:returntype", void 0)
    ], Profile.prototype, "setUsertimeZone", null);
    __decorate([
        Watch("userDateFormat"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, Object]),
        __metadata("design:returntype", void 0)
    ], Profile.prototype, "setUserDateFormat", null);
    Profile = __decorate([
        Component({
            name: "Profile",
            components: {
                Layout,
                PageHeader,
                SectionLoader,
            },
        })
    ], Profile);
    return Profile;
})();
export default Profile;
